export default "__VITE_ASSET__yh6yUcq5__"